// Decides whether we are serving the public marketing site (custom domain)
// instead of the full app (preview, localhost, native Capacitor app).
const MARKETING_HOSTS = [
  "xn--frstesmak-l8a.no",
  "www.xn--frstesmak-l8a.no",
  "førstesmak.no",
  "www.førstesmak.no",
  "forstesmak.no",
  "www.forstesmak.no",
  "forstesmak.lovable.app",
];

function isNative(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return !!cap?.isNativePlatform?.();
}

export function isMarketingSite(): boolean {
  if (typeof window === "undefined") return false;
  if (isNative()) return false;
  // Testing override: ?site=marketing (stored for the session)
  try {
    const param = new URLSearchParams(window.location.search).get("site");
    if (param === "marketing") sessionStorage.setItem("site_mode", "marketing");
    if (param === "app") sessionStorage.removeItem("site_mode");
    if (sessionStorage.getItem("site_mode") === "marketing") return true;
  } catch {
    /* ignore */
  }
  return MARKETING_HOSTS.includes(window.location.hostname.toLowerCase());
}
